export function findCircularReference() {
  const seen = new WeakMap()

  return function (key, value) {
    if (typeof value === 'object' && value !== null) {
      if (seen.has(value)) {
        return
      }
      seen.set(value, key)
    }
    return value
  }
}
